import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=a54affe4&scoped=true&"
import script from "./HomeProfile.vue?vue&type=script&lang=js&"
export * from "./HomeProfile.vue?vue&type=script&lang=js&"
import style0 from "./HomeProfile.vue?vue&type=style&index=0&id=a54affe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54affe4",
  null
  
)

export default component.exports